import { render, staticRenderFns } from "./postModel.vue?vue&type=template&id=2fe43f06&scoped=true"
import script from "./postModel.vue?vue&type=script&lang=js"
export * from "./postModel.vue?vue&type=script&lang=js"
import style0 from "./postModel.vue?vue&type=style&index=0&id=2fe43f06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe43f06",
  null
  
)

export default component.exports